import { render, staticRenderFns } from "./Ugd.vue?vue&type=template&id=ac3b1c22&"
import script from "./Ugd.vue?vue&type=script&lang=js&"
export * from "./Ugd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports